export const CIPP_V1ResourcesDE: CIPP_V1ResourcesBSInterface = {
  labelDone: "Datum der Aufgabenerledigung",
  evidencijaForm: {
    buttonForward: "Unterschreiben",
    buttonBack: "Zurück",
  },
  successModal: {
    title: "Dateneingabe",
    body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
  errors: {
    recordAlreadyExists:
      "Diese Evidenz wurde bereits ausgefüllt. Sie können sie nicht erneut ausfüllen.",
  },
};

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

export interface CIPP_V1ResourcesBSInterface {
  labelDone: string;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errors: {
    recordAlreadyExists: string;
  };
}
